import { CodingModel } from '@lib/guarantees/data-access';

/** How many entries a dictionary is asked for at once. */
export const DICTIONARY_PAGE_SIZE = 50;

/**
 * How well an entry answers what was typed. Every dictionary matches a substring across the code
 * *and* the names and then orders by code, so a search for "K" answers with A-codes containing a k.
 * Ranking here puts what was asked for first: the term itself, then a name that starts with it, then
 * anything merely containing it.
 */
function relevance(entry: CodingModel, term: string): number {
  const code = entry.code?.toLowerCase() ?? '';
  const name = entry.name?.toLowerCase() ?? '';

  if (code === term || name === term) {
    return 0;
  }
  if (code.startsWith(term)) {
    return 1;
  }
  if (name.startsWith(term)) {
    return 2;
  }
  if (code.includes(term)) {
    return 3;
  }

  return 4;
}

/**
 * Ranked first, then by code within a rank, so equally relevant entries stay in dictionary order.
 * Shared by every dictionary lookup, so one term cannot come back in two different orders in two
 * places.
 */
export function byRelevance<T>(term: string, describe: (item: T) => CodingModel) {
  const lowered = term.toLowerCase();

  return (a: T, b: T): number => {
    const first = describe(a);
    const second = describe(b);

    return relevance(first, lowered) - relevance(second, lowered) || (first.code ?? '').localeCompare(second.code ?? '');
  };
}
